import React, { useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import { connect } from "react-redux";

import { Redirect } from "react-router";

import { login, validateAccountUpgrade } from "../../store/actions";
import { decodeUserSession } from "../../utils/utils";
import LoadingPage from "./LoadingPage";
import { getLocale } from "../../utils/locale";
import { AUTH_CONFIG } from "../../environmentVariables";

const SSOCallback = (props) => {
    const [loginAttempt, setAttempt] = useState(false);
    const auth = useAuth();

    const [accountConfirmed, setAccountConfirmed] = useState(false);
    const { user, login, match, validateAccountUpgrade } = props;

    const locale = getLocale(auth, match);

    const userInformation = decodeUserSession(user);

    useEffect(() => {
        window.localStorage.setItem("login-mode", "sso");
    }, []);

    useEffect(() => {
        if (!loginAttempt && !auth?.isLoading && auth?.isAuthenticated && !userInformation) {
            login(
                auth?.user?.profile?.email,
                auth?.user?.id_token,
                "SSO",
                {
                    setAttempt: setAttempt,
                },
                auth,
                AUTH_CONFIG["sso"].jwks_uri,
                locale,
            );
        }
    }, [userInformation, login, auth, loginAttempt, locale]);

    if (!auth?.isLoading && auth?.error) {
        return <Redirect to={`/${locale}/unauthorized`} />;
    }

    if (!auth?.isLoading && !auth?.isAuthenticated && !userInformation) {
        return <Redirect to={`/${locale}/login`} push />;
    }

    if (!auth?.isLoading && auth?.isAuthenticated && userInformation) {
        if (loginAttempt && userInformation && accountConfirmed) {
            return <Redirect to={`/${locale}/`} push />;
        }
        if (!userInformation.hasUpgradedAccount) {
            validateAccountUpgrade().then(() => setAccountConfirmed(true));
        } else {
            return <Redirect to={`/${locale}/`} push />;
        }
    }

    if (loginAttempt && !auth?.isLoading && auth?.isAuthenticated && !userInformation) {
        return <Redirect to={`/${locale}/forbidden`} />;
    }

    return <LoadingPage />;
};

export default connect(({ user }) => ({ user }), { login, validateAccountUpgrade })(SSOCallback);
